let ipDetectedRegionCode;
let ipDetectedRegionCountry;
const controllers = {};
const ipDetectionProviders = {
    ipapico: {
        url: 'https://ipapi.co/json',
        country_code_attribute: 'country_code',
        country_name: 'country_name',
    },
    geolizr: {
        url: 'https://service.geolizr.com/ipapi/',
        country_code_attribute: 'countryCode',
        country_name: 'country',
    },
    // To use geoip2 you must add the script to your theme.liquid file. Check the documentation on geoip2 here https://dev.maxmind.com/geoip/geoip2/javascript/
    geoip2: {
        url: 'not required',
    },
};
const init = () => {
    ipDetectedRegionCode = localStorage.getItem('ipDetectedRegionCode');
    ipDetectedRegionCountry = localStorage.getItem('ipDetectedRegionCountry');
    if (!ipDetectedRegionCode) {
        checkIP();
    }
    else {
        dispatchEvent();
    }
};
const setIPRegion = (countryCode, countryName) => {
    ipDetectedRegionCode = countryCode;
    ipDetectedRegionCountry = countryName;
    localStorage.setItem('ipDetectedRegionCode', countryCode);
    localStorage.setItem('ipDetectedRegionCountry', countryName);
    dispatchEvent();
};
const dispatchEvent = () => {
    window.dispatchEvent(new CustomEvent('region-country-code-detected', {
        detail: {
            ipDetectedRegionCode,
            ipDetectedRegionCountry,
        },
    }));
};
const checkIP = () => {
    Object.keys(ipDetectionProviders).forEach((key) => {
        if (key === 'geoip2') {
            if (typeof geoip2 !== 'undefined') {
                geoip2.country((location) => {
                    setIPRegion(location.country.iso_code, location.country.names.en);
                    Object.keys(controllers).forEach((controllerKey) => {
                        if (key !== controllerKey) {
                            controllers[controllerKey].abort();
                        }
                    });
                });
            }
        }
        else {
            const controller = new AbortController();
            const url = ipDetectionProviders[key].url;
            const country_code_attribute = ipDetectionProviders[key].country_code_attribute;
            const country_name = ipDetectionProviders[key].country_name;
            controllers[key] = controller;
            try {
                fetch(url, {
                    signal: controller.signal,
                })
                    .then((response) => {
                    return response.json();
                })
                    .then((data) => {
                    //Once the first provider has return a response, abort all the other requests.
                    if (undefined !== data[country_code_attribute]) {
                        Object.keys(controllers).forEach((controllerKey) => {
                            if (key !== controllerKey) {
                                controllers[controllerKey].abort();
                            }
                        });
                        setIPRegion(data[country_code_attribute], data[country_name]);
                    }
                });
            }
            catch (err) {
                if (err.name == 'AbortError') {
                    // handle abort()
                }
                else {
                    throw err;
                }
            }
        }
    });
};
export default init;
